/* src/app/shared/dialog/region-dialog/region-dialog.component.scss */
.container {
  display: flex;
  width: 300px;
  flex-direction: column;
  align-items: flex-start;
  gap: 25px;
  border-radius: 20px;
  background: #FFF;
}
.title {
  color: #001A33;
  font: 700 16px FranceTV Brown;
  line-height: normal;
}
.dialog-body {
  height: 400px;
  overflow-y: auto;
}
.horizontal-separator {
  height: 1px;
  background-color: #DFEBF7;
  height: 1px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
}
.filter-selection {
  width: 300px;
  border-radius: 5px;
  border: 1px solid #DFEBF7;
  height: 55px;
}
.action-button {
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
}
.action-button button {
  flex: 1;
}
.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
/*# sourceMappingURL=region-dialog.component.css.map */
